import usePlan from '../composables/usePlan'
import useEnv from '../composables/useEnv'
import usePhotoService from './usePhotoService'
import useRestNode from '../composables/useRestNode'
import { RESTStatus } from '../types/common.js'
import { useLogger } from '../server/utils/useLogger'

/**
 * The purpose of this service is to provide functionality for retrieving and hydrating online clinics.
 */
export default () => {

    const { locationServiceEndpoint, networkServiceEndpoint } = useEnv()
    const { get } = useRestNode()
    const logger = useLogger()

    const getOnlineClinics = async (profile, context, careConcepts) => {
        const { getPlan, getNetworkId } = usePlan(profile, context)
        const stateSearched = await getState(context.latLong)
        const name = context.name
        const networdId = getNetworkId()
        const state = stateSearched ? stateSearched : profile.state
        const plan = getPlan()
        const groupId = plan.coverageInfo != null ? plan.coverageInfo.groupNumber : ''
        const asOfDate = context.asOfDate    
        try {
            const results = await searchOnlineLocations(networdId, state, name, careConcepts, groupId, asOfDate) 
            await applyPhotos(results)    
            console.log("Returning onlineClinics", results.length)
            return results
        } catch (error) {
            return null
        }
    }

    const applyPhotos = async (onlineClinics) => {
        const photos = await getOnlineClinicPhotos(onlineClinics)
        if (photos) {
          onlineClinics.forEach((item) => {
            const photo = photos[item.id]
            if (photo) item.photoUrl = photo.url
          })
        }        
    }

    const searchOnlineLocations = async (networkId, states, name, careConcepts, groupId, asOfDate) => {  
        try {
            const url = new URL(`${locationServiceEndpoint}/search-online-clinics/network/${networkId}?states=${states}`)
            if (careConcepts) url.searchParams.append('careConcepts', careConcepts.join())
            if (name) url.searchParams.append('name', name)
            if (groupId) url.searchParams.append('employerGroupId', groupId)
            if (asOfDate) url.searchParams.append('asof', asOfDate)
            const result = await get(url.toString())
            // return result.status == 'Ok' ? result.value : null
            return result.status == RESTStatus.Ok ? result.value : null
        } catch (error) {
            console.log(error)
            return null
        }
    }      

    const getState = async (latLong) => {   
        const latLongSplit = latLong.split(",")
        const lat = latLongSplit[0]
        const long = latLongSplit[1]
        try {
            const url = new URL(`${networkServiceEndpoint}/usps-state/latitude/${lat}/longitude/${long}`)
            logger.info(`online clinic: /usps-state/latitude/${lat}/longitude/${long}`)
            const result = await get(url.toString())
            return result.status == RESTStatus.Ok ? result.value : null
        } catch (error) {
            console.log(error)
            return null
        }
    }    
      
    /**
     * get photos from photo-service for online clinics
     */ 
    const getOnlineClinicPhotos = async (onlineClinics) => {
        const { onlineClinicPhotos } = usePhotoService()
        try {
            const results = await onlineClinicPhotos(onlineClinics)
            return results
        } catch (error) {
            return null
        }
    }   
    
    return { getOnlineClinics }

}